import { Buttons, CancelButton, DeleteButton, Field, Form, ModalCard } from '~/components';
import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

function RejectTimeDialog({ count, onResolve }) {
  const handleClose = () => {
    onResolve(null);
  };

  const handleSubmit = (values) => {
    onResolve(values.reason);
  };

  return (
    <ModalCard title="Reject Time" onClose={handleClose}>
      <Formik
        enableReinitialize
        initialValues={{ reason: '' }}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          reason: Yup.string().label('Reason').max(255).required(),
        })}>
        <Form>
          <ModalCard.Body>
            <Form.Control>
              <Field.Text name="reason" placeholder="Reason" maxLength={255} autoFocus />
            </Form.Control>
          </ModalCard.Body>
          <ModalCard.Footer>
            <Buttons align="right">
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
              <DeleteButton type="submit">
                Reject {count} time {count === 1 ? 'entry' : 'entries'}
              </DeleteButton>
            </Buttons>
          </ModalCard.Footer>
        </Form>
      </Formik>
    </ModalCard>
  );
}

export default RejectTimeDialog;
